import { AxiosResponse } from 'axios';
import { accaResultAxios } from '@repository/publicAcc/AccaResultAxios';
import { AccApplyResultRs } from '@domain/rs/acca/v1/test/result/apply/AccApplyResultRs';
import { AccSelfReportResultRs } from '@domain/rs/acca/v1/test/result/apply/AccSelfReportResultRs';
import { AccVideoResultRs } from '@domain/rs/acca/v1/test/result/apply/AccVideoResultRs';
import { AccGameResultRs } from '@domain/rs/acca/v1/test/result/apply/AccGameResultRs';
import { AccApplyTipRs } from '@domain/rs/acca/v1/test/result/apply/AccApplyTipRs';
import { AccProfileResultRs } from '@domain/rs/acca/v1/test/result/competence/AccProfileResultRs';
import { AccCompanyCurationRs } from '@domain/rs/acca/v1/test/result/competence/AccCompanyCurationRs';
import { AccJobCurationRs } from '@domain/rs/acca/v1/test/result/competence/AccJobCurationRs';
import { PublicAccApplyUserStatusRs } from '@domain/rs/acca/v1/test/result/PublicAccApplyUserStatusRs';
import AccResultTokenCreateRs from '@domain/rs/acca/v1/test/result/AccResultTokenCreateRs';

const publicPrefix = '/public/v1';
const accApplyPrefix = '/acc/apply';
const accCompetencePrefix = '/acc/competence';

/** 외부에서 요청하는 신역검 결과표 **/
export default interface PublicAccRepo {
  /** 커리어센터 결과표 정보 조회 **/

  fetchAccStatusUser(code: string): Promise<AxiosResponse<PublicAccApplyUserStatusRs>>;

  // 응시 분석 결과표 토큰 발급(V3)
  fetchAccStatusToken(code: string): Promise<AxiosResponse<AccResultTokenCreateRs>>;

  /** 신역검 응시 분석 결과 **/

  // 종합 응시 결과, 과정별 피드백
  fetchAccApplyResult(code: string): Promise<AxiosResponse<AccApplyResultRs>>;

  // 성향 파악 응시 결과
  fetchAccApplySelfReport(code: string): Promise<AxiosResponse<AccSelfReportResultRs>>;

  // 영상 면접 응시 결과
  fetchAccApplyVideo(code: string): Promise<AxiosResponse<AccVideoResultRs>>;

  // 전략 게임 응시 결과
  fetchAccApplyGame(code: string): Promise<AxiosResponse<AccGameResultRs>>;

  // 맞춤형 꿀팁
  fetchAccApplyTip(code: string): Promise<AxiosResponse<AccApplyTipRs>>;

  /** 신역검 역량 분석 결과 **/

  // 역량 유형, 역량 프로파일, 면접 예상 질문 가이드
  fetchAccCompetenceProfile(code: string): Promise<AxiosResponse<AccProfileResultRs>>;

  // 기업 문화 추천
  fetchAccCompetenceCurationCompany(code: string): Promise<AxiosResponse<AccCompanyCurationRs>>;

  // 직군/직무 추천
  fetchAccCompetenceCurationJob(code: string): Promise<AxiosResponse<AccJobCurationRs>>;
}

export class RemotePublicAccRepo implements PublicAccRepo {
  /** 커리어센터 결과표 정보 **/

  fetchAccStatusUser(code: string): Promise<AxiosResponse<PublicAccApplyUserStatusRs>> {
    return accaResultAxios.get(`${publicPrefix}/acc/status/user`, { params: { code } });
  }

  fetchAccStatusToken(code: string): Promise<AxiosResponse<AccResultTokenCreateRs>> {
    return accaResultAxios.get(`${publicPrefix}/acc/status/token`, { params: { code } });
  }

  /** 신역검 응시 분석 결과 **/

  fetchAccApplyResult(code: string): Promise<AxiosResponse<AccApplyResultRs>> {
    return accaResultAxios.get(`${publicPrefix}${accApplyPrefix}/result`, { params: { code } });
  }

  fetchAccApplySelfReport(code: string): Promise<AxiosResponse<AccSelfReportResultRs>> {
    return accaResultAxios.get(`${publicPrefix}${accApplyPrefix}/self-report`, { params: { code } });
  }

  fetchAccApplyVideo(code: string): Promise<AxiosResponse<AccVideoResultRs>> {
    return accaResultAxios.get(`${publicPrefix}${accApplyPrefix}/video`, { params: { code } });
  }

  fetchAccApplyGame(code: string): Promise<AxiosResponse<AccGameResultRs>> {
    return accaResultAxios.get(`${publicPrefix}${accApplyPrefix}/game`, { params: { code } });
  }

  fetchAccApplyTip(code: string): Promise<AxiosResponse<AccApplyTipRs>> {
    return accaResultAxios.get(`${publicPrefix}${accApplyPrefix}/tip`, { params: { code } });
  }

  /** 신역검 역량 분석 결과 **/

  fetchAccCompetenceProfile(code: string): Promise<AxiosResponse<AccProfileResultRs>> {
    return accaResultAxios.get(`${publicPrefix}${accCompetencePrefix}/profile`, { params: { code } });
  }

  fetchAccCompetenceCurationCompany(code: string): Promise<AxiosResponse<AccCompanyCurationRs>> {
    return accaResultAxios.get(`${publicPrefix}${accCompetencePrefix}/curation/company`, { params: { code } });
  }

  fetchAccCompetenceCurationJob(code: string): Promise<AxiosResponse<AccJobCurationRs>> {
    return accaResultAxios.get(`${publicPrefix}${accCompetencePrefix}/curation/job`, { params: { code } });
  }
}
